import './App.css';
import Home from './Components/Home/Home';
import Navbar from './Components/Navbar/Navbar';

function App() {
  return <>
  <Navbar/>
  <Home/>
  </>
}

export default App;
